import { useToast } from "@chakra-ui/react";
import useReceivingSector from "hooks/use-receiving";
import { IManagerProductContext } from "Interfaces/Providers/ManagerProduct";
import { createContext, ReactNode, useCallback, useState } from "react";
import inventory from "services/inventory";
import managerProduct from "services/manager-product";
import { useImmer } from "use-immer";

import { IInventoryContext } from "../../Interfaces/Providers/Inventory";
interface Auth0ProviderProps {
  children: ReactNode;
}

const ManagerProductProvider = ({ children }: Auth0ProviderProps) => {
  const toast = useToast();
  const { getDataStructure } = useReceivingSector();
  const [loading, setLoading] = useState(false);
  const [isFirstData, setFirstData] = useState(true);

  const [data, updateData] = useImmer<any[]>([]);
  const [dataCombo, updateDataCombo] = useImmer<any[]>([]);

  const [loadingHistoric, setLoadingHistoric] = useState(false);
  const [dataHistoric, updateDataHistoric] = useImmer<any[]>([]);

  const getDataHistoric = useCallback(async () => {
    setLoadingHistoric(true);
    setFirstData(false);

    inventory
      .getInventoryHistoric()
      .then((response) => {
        updateDataHistoric(response.data?.data);
        setLoadingHistoric(false);
      })
      .catch(() => {
        setLoadingHistoric(false);
      });
  }, [updateDataHistoric]);
  const getData = useCallback(async () => {
    setLoading(true);
    setFirstData(false);

    managerProduct
      .getManagerSettings()
      .then((response) => {
        updateData(response.data?.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [updateData]);

  const getDataCombo = useCallback(async () => {
    setLoading(true);
    setFirstData(false);

    managerProduct
      .getManagers()
      .then((response) => {
        updateDataCombo(response.data?.data);
        setLoading(false);
      })
      .catch(() => {
        updateDataCombo([]);
        setLoading(false);
      });
  }, [updateDataCombo]);

  const postData = useCallback(
    async (obj: any) => {
      setLoading(true);
      setFirstData(false);

      managerProduct
        .postManagers(obj)
        .then((response) => {
          getData();
          getDataCombo();
          getDataStructure();
          toast({
            title: "Gerente Associado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        })
        .catch(() => {
          setLoading(false);
          toast({
            title: "Error ao cadastrar..",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        });
    },
    [getData, getDataCombo, getDataStructure, toast]
  );

  const putData = useCallback(
    async (obj: any, id: any) => {
      setLoading(true);
      setFirstData(false);

      inventory
        .putInventory(obj, id)
        .then((response) => {
          setLoading(false);
          getData();
          getDataStructure();
          toast({
            title: "Inventário atualizado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        })
        .catch(() => {
          setLoading(false);
          toast({
            title: "Error ao atualizar..",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        });
    },
    [updateData]
  );

  const deleteData = useCallback(
    async (id: number) => {
      setLoading(true);
      setFirstData(false);

      managerProduct
        .deleteManagers(id)
        .then((response) => {
          getData();
          getDataStructure();
          getDataCombo();
          toast({
            title: "Gerente Desassociado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        })
        .catch(() => {
          setLoading(false);
          toast({
            title: "Error ao deletar..",
            status: "error",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        });
    },
    [getData, getDataStructure, toast]
  );

  return (
    <ManagerProductContext.Provider
      value={{
        loading,
        data,
        isFirstData,
        dataCombo,
        getDataCombo,
        getData,
        deleteData,
        putData,
        postData,
        dataHistoric,
        loadingHistoric,
        getDataHistoric,
      }}
    >
      {children}
    </ManagerProductContext.Provider>
  );
};

export default ManagerProductProvider;
export const ManagerProductContext = createContext<IManagerProductContext>(
  {} as IManagerProductContext
);
